<template>
  <sc-page-base
    :title="pageTitle"
    :loading="loading"
  >
    <sc-grid
      ref="sc-grid"
      :data="refunds.items"
      :default-filters="defaultFilters"
      @submit="getDataTableReport($event)"
      :message="'Nenhum resultado encontrado'"
      :rules="rules"
      :has-backend-sorting="false"
      :has-backend-pagination="false"
      :total="refunds.items.length"
      default-sort-column="status"
      default-sort-direction="asc"
    >

      <template
        slot="filters-actions"
        slot-scope="{ isValid, filters }"
      >

        <sc-button
          text="Exportar para o Excel"
          @click="exportRefundToExcel(filters)"
        />

        <sc-button
          type="button"
          text="Limpar filtros"
          :loading="loading"
          @click="resetFilters()"
        />

        <sc-button
          type="submit"
          theme="primary"
          text="Buscar"
          :loading="loading"
        />
      </template>

      <template
        slot="filters"
        slot-scope="{ filters }"
      >
        <div class="columns">
          <div class="column is-2">
            <sc-field
              label="Buscar por"
              prop="type_filter"
            >
              <sc-select
                v-model="componentRender"
                @input="changeComponent(componentRender)"
              >

                <option :value="component.value" v-for="(component, index) in componentDataObject" :key="index">{{component.name}}</option>

              </sc-select>
            </sc-field>
          </div>

          <div class="column">

          <component
            :is="componentRender"
            :rules="rules"
            :filters="filters"
            :component-render="componentRender.component"
          />
          </div>
        </div>

      </template>

      <template
        slot="table-columns"
        slot-scope="{ props }"
      >
        <sc-table-column
          field="status"
          label="Status da PI"
          sortable
        >
          {{ props.row.status }}
        </sc-table-column>
        <sc-table-column
          field="substatus"
          label="Substatus do PI"
          sortable
        >
          {{ props.row.substatus }}
        </sc-table-column>
        <sc-table-column
          field="number"
          label="Número do PI"
          sortable
        >
          {{ props.row.number }}
        </sc-table-column>
        <sc-table-column
          field="reason_for_pidescription"
          label="Motivo de abertura"
          sortable
        >
          {{ props.row.reason_for_pidescription }}
        </sc-table-column>
        <sc-table-column
          field="tracking_code"
          label="Código de rastreamento"
          sortable
        >
          {{ props.row.tracking_code }}
        </sc-table-column>
        <sc-table-column
          field="order_number"
          label="Pedido"
          sortable
        >
          {{ props.row.order_number }}
        </sc-table-column>
        <sc-table-column
          field="end_customer_name"
          label="Destinatário"
          sortable
        >
          {{ props.row.end_customer_name }}
        </sc-table-column>
        <sc-table-column
          field="delivery_estimate_lp"
          label="Previsão da transportadora"
          sortable
        >
          {{ props.row.delivery_estimate_lp | date }}
        </sc-table-column>
        <sc-table-column
          field="answer_deadline"
          label="Prazo da resposta"
          sortable
        >
          {{ props.row.answer_deadline | date }}
        </sc-table-column>
        <sc-table-column
          field="last_tracking_status"
          label="Último rastreamento"
          sortable
        >
          {{ props.row.last_tracking_status }}
        </sc-table-column>
      </template>
    </sc-grid>
  </sc-page-base>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScPageBase,
  ScField,
  ScGrid,
  ScRangeDatePicker,
  ScButton,
  ScSelect,
  ScSwitch,
  ScTableColumn,
} from '@intelipost-js/secure-components';
import { Moment, Storage } from '@intelipost-js/secure-providers';

import FilterByDate from './components/FilterByDate';
import FilterByOrderNumber from './components/FilterByOrderNumber';
import FilterByPiNumber from './components/FilterByPiNumber';
import FilterByTrackingCode from './components/FilterByTrackingCode';

const {
  mapState,
  mapActions,
  } = createNamespacedHelpers('refund/export');

export default {
  name: 'page-refund',
  data() {
    return {
      componentRender: 'FilterByDate',
      defaultFilters: {
        type_filter: 'FilterByDate',
        date_range: {
          start: Moment().format('YYYY-MM-DD'),
          end: Moment()
            .add(15, 'day')
            .format('YYYY-MM-DD'),
        },
        date_range_response: {
          start: Moment().format('YYYY-MM-DD'),
          end: Moment()
            .add(15, 'day')
            .format('YYYY-MM-DD'),
        },
      },
      rules: {
        type_filter: [
          {
            required: true,
          },
        ],
        pi_numbers: [
          {
            type: Object,
            required: false,
            validator: (rule, value, callback) => {
              if (this.componentRender === 'FilterByPiNumber' && !value) {
                // eslint-disable-next-line
                rule.required = true;
                callback(
                    new Error(
                      'Preencher o campo<strong> número de PI</strong>',
                    ),
                  );
              }
              callback();
            },
          },
        ],
        order_numbers: [
          {
            type: Array,
            required: false,
            validator: (rule, value, callback) => {
              if (this.componentRender === 'FilterByOrderNumber' && !value) {
                // eslint-disable-next-line
                rule.required = true;
                callback(
                    new Error(
                      'Preencher o campo<strong> número pedido</strong>',
                    ),
                  );
              }
              callback();
            },
          },
        ],
        tracking_codes: [
          {
            type: Array,
            required: false,
            validator: (rule, value, callback) => {
              if (this.componentRender === 'FilterByTrackingCode' && !value) {
                // eslint-disable-next-line
                rule.required = true;

                callback(
                    new Error(
                      'Preencher o campo<strong> número pedido</strong>',
                    ),
                  );
              }
              callback();
            },
          },
        ],
        date_range: [
          {
            type: Object,
            required: true,
            message:
              'Preencha o período com no máximo <strong>31 dias</strong>',
            validator: (rule, value, callback, fields) => {
              const {
                date_range_response,
                } = fields;
              if (
                (date_range_response && date_range_response.start) ||
                (date_range_response && date_range_response.end)
              ) {
                // eslint-disable-next-line
                rule.required = false;
                callback();
              }

              const {
                start,
                end,
              } = value || {};
              const begin = Moment(start, 'YYYY-MM-DD');
              const finish = Moment(end, 'YYYY-MM-DD');
              const diff = Moment.duration(begin.diff(finish)).asDays() * -1;

              if (diff > 31 || !value) {
                callback(new Error());
              }

              callback();
            },
          },
        ],
        date_range_response: [
          {
            type: Object,
            required: true,
            message:
              'Preencha o período com no máximo <strong>31 dias</strong>',
            validator: (rule, value, callback, fields) => {
              const {
                date_range,
                } = fields;
              if (
                (date_range && date_range.start) ||
                (date_range && date_range.end)
              ) {
                // eslint-disable-next-line
                rule.required = false;
                callback();
              }

              const { start, end } = value || {};
              const begin = Moment(start, 'YYYY-MM-DD');
              const finish = Moment(end, 'YYYY-MM-DD');
              const diff = Moment.duration(begin.diff(finish)).asDays() * -1;

              if (diff > 31 || !value) {
                callback(new Error());
              }

              callback();
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(['loading', 'refunds', 'status_pi', 'sub_status_pi']),
    componentDataObject() {
      return [
        {
          value: 'FilterByDate',
          name: 'Filtros',
        },
        {
          value: 'FilterByTrackingCode',
          name: 'Código de rastreio',
        },
        {
          value: 'FilterByOrderNumber',
          name: 'Número do pedido',
        },
        {
          value: 'FilterByPiNumber',
          name: 'Número do PI',
        },
      ];
    },
    pageTitle() {
      const originMenu = Storage.get('originMenu', 'local') || 'oldmenu';
      return originMenu === 'newmenu' ? 'Reembolso de PI' : 'Reembolso';
    },
  },
  methods: {
    ...mapActions(['getRefundReport', 'getRefundExport', 'getSubStatusPi', 'getStatusPi']),
    exportRefundToExcel(filters) {
      const type_filter = this.componentRender;
      return this.getRefundExport({
        filters: {
          ...filters,
          type_filter,
        },
      });
    },
    getDataTableReport(config) {
      const {
        filters,
        } = config;
      const type_filter = this.componentRender;

      return this.getRefundReport({
        filters: {
          ...filters,
          type_filter,
        },
      });
    },
    resetFilters() {
      this.$refs['sc-grid'].clearFilters();
    },
    changeComponent(value) {
      this.componentRender = value;
    },
  },
  created() {
    this.getSubStatusPi();
    this.getStatusPi();
  },
  components: {
    ScPageBase,
    ScField,
    ScGrid,
    ScRangeDatePicker,
    ScButton,
    ScSelect,
    ScSwitch,
    ScTableColumn,
    FilterByDate,
    FilterByOrderNumber,
    FilterByPiNumber,
    FilterByTrackingCode,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-refund/features/export-xls/PageRefund.vue